export function convertBase64toBlob(content, contentType) {
  contentType = contentType || '';
  let sliceSize = 512;
  let byteCharacters = window.atob(content); //method which converts base64 to binary
  let byteArrays = [
  ];
  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    let slice = byteCharacters.slice(offset, offset + sliceSize);
    let byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }
    let byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }
  let blob = new Blob(byteArrays, {
    type: contentType
  }); //statement which creates the blob
  return blob;
}

interface PaginationResponse {
  totalCount: number;
  pageSize: number;
  currentPageSize: number;
  currentStartIndex: number;
  currentEndIndex: number;
  pageNumber: number;
  totalPages: number;
  hasPrevious: boolean;
  hasNext: boolean;
}

export interface PagedResponse<T> {
  list: T[];
  pagination: PaginationResponse;
}

export function getPagedResponse<T>(response: any, meta: any, arg: any): PagedResponse<T> {
  const pagination = JSON.parse(meta.response.headers.get("X-Pagination") as string);
  return {
    list: response,
    pagination: pagination
  };
}

export function parseValue<T extends string | number>(val: any): T {
  try {
    if (!isNaN(val) && typeof val === "string") {
      return Number(val) as T;
    }
    return val as T;
  } catch (err) {
    console.error("Failed to parse value:", err);
    return val;
  }
}
